import { render, staticRenderFns } from "./Alerta.vue?vue&type=template&id=64fc5e5c&scoped=true&"
import script from "./Alerta.vue?vue&type=script&lang=js&"
export * from "./Alerta.vue?vue&type=script&lang=js&"
import style0 from "./Alerta.vue?vue&type=style&index=0&id=64fc5e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc5e5c",
  null
  
)

export default component.exports